
import { Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";

import { Announcements, Commission,Projects, ConsultationRequest,InsurancePolicyList, Faq, Installment , Policy, PrePayment, Profile, Toturial, UnderConstruction , InsuranceRate, Inquery, ProfileNotFound, Issuing , OffersList, OffersDetails, Preview, NotFound , Uitlink , UitlinkIssuing, UniversalIssuing, ServerError, Universal, Transactions, AgentSignUp, AgentEdit } from "./views/pages";
import routes from "./core/routes";
import { HTMLAttributes, ReactElement, useEffect } from "react";
import { connect } from "react-redux";
import { AppConstants } from "./core/constants";
import Cookies from "js-cookie";


interface Props extends HTMLAttributes<HTMLElement> {
  dispatch?: any;
}
function App(): ReactElement {
  useEffect(() => {
    Cookies.set('domain',"portal", { path: '/', domain:`${AppConstants.domain}`  })
  }, []);
  return (
    <Routes>
      <Route path={routes.DASHBOARD} element={<Preview />} />
      <Route path={routes.PROFILE} element={<Profile />} />
      <Route path={routes.FAQ} element={<Faq />} />
      <Route path={routes.TOTURIAL} element={<Toturial />} />
      <Route path={routes.ANNOUNCEMENTS} element={<Announcements />} />
      <Route path={routes.POLICY} element={<Policy />} />
      <Route path={routes.INSURANCEPOLICY} element={<InsurancePolicyList />} />
      <Route path={routes.CONSULTATION} element={<ConsultationRequest />} />
      <Route path={routes.COMMISSION} element={<Commission />} />
      <Route path={routes.INSTALLMENT} element={<Installment />} />
      <Route path={routes.UNDERCONSTRUCTION} element={<UnderConstruction />} />
      <Route path={routes.PREPAYMENT} element={<PrePayment />} />
      <Route path={routes.INSURANCERATE} element={<InsuranceRate />} />
      <Route path={routes.INQUERY} element={<Inquery />} />
      <Route path={routes.ISSUING} element={<Issuing />} />
      <Route path={routes.PROFILENOTFOUND} element={<ProfileNotFound />} />
      <Route path={routes.OFFERSLIST} element={<OffersList />} />
      <Route path={routes.OFFERSDETAILS} element={<OffersDetails />} />
      <Route path={routes.UNITLINK} element={<Uitlink />} />
      <Route path={routes.UNITLINKISSUING} element={<UitlinkIssuing />} />
      <Route path={routes.TRANSACTIONS} element={<Transactions />} />
      
      <Route path={routes.AGENTSIGNUP} element={<AgentSignUp />} />
      <Route path={routes.AGENTEDIT} element={<AgentEdit />} />

      <Route path={routes.PROJECTS} element={<Projects />} />
      <Route path={routes.UNIVERSAL} element={<Universal />} />



      <Route path={routes.UNIVERALUPDATE} element={<Universal />} />
      <Route path={routes.UNIVERALISSUINGUPDATE} element={<UniversalIssuing />} />



      <Route path={routes.UNIVERALISSUING} element={<UniversalIssuing />} />      
      <Route path={routes.SERVERERROR} element={<ServerError />} />


      <Route path={routes.UNITLINKUPDATE} element={<Uitlink />} />
      <Route path={routes.UNITLINKISSUINGUPDATE} element={<UitlinkIssuing />} />


      <Route path={routes.INQUERYUPDATE} element={<Inquery />} />
      <Route path={routes.ISSUINGUPDATE} element={<Issuing />} />


      
      {/* <Route path="*" element={<NotFound />} /> */}
    </Routes>
  );
}

const mapStateToProps = (dispatch: any) => {
  return {
    dispatch,
    userData: dispatch.general.userData,
  };
};
export default connect(mapStateToProps)(App);
